import { createContext, use } from 'react';

// Its own module so the gate can read it without importing the provider, which pulls in
// `PermissionsProvider` and the workspace and role queries.

// True without the provider: nothing there will load later, so today's answer is final.
export const PermissionsResolvedContext = createContext(true);

/**
 * Whether every input the permission check reads has loaded. `checkPermission`
 * answers `false` for a missing account, user, role list or workspace, so a
 * denial read while this is `false` is not an answer yet.
 */
export function usePermissionsResolved(): boolean {
  return use(PermissionsResolvedContext);
}
